import { action } from '@ember/object';
import Component from '@glimmer/component';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormCheckboxComponent from 'webapp/components/form/checkbox';

import type Tag from 'webapp/models-custom/tag';

interface Args {
	tag: Tag;
	selected: number[];
	newSelected: number[];
	theme?: string | null;
	onAddToNewSelected: (tagId: number) => void;
	onRemoveFromNewSelected: (tagId: number) => void;
}

export default class TagSelectComponent extends Component<Args> {
	get tagId(): number {
		return this.args.tag.numericId!;
	}

	get isChecked(): boolean {
		return this.args.newSelected.includes(this.tagId);
	}

	get wasSelectedBefore(): boolean {
		return this.args.selected.includes(this.tagId) && this.isChecked;
	}

	@action
	changeChecked(isChecked: boolean): void {
		const tagId = this.tagId;

		if (isChecked) {
			this.args.onAddToNewSelected(tagId);
		} else {
			this.args.onRemoveFromNewSelected(tagId);
		}
	}
	<template>
		<li
			class="{{if this.isChecked 'selected'}}
				{{if this.wasSelectedBefore 'selected--before'}}"
		>
			<FormCheckboxComponent
				@selected={{this.isChecked}}
				@label={{@tag.name}}
				@scrollableLabel={{true}}
				@theme={{@theme}}
				@onChange={{this.changeChecked}}
			/>
			{{#if this.wasSelectedBefore}}
				<CommonUiIconComponent @name="Minus" @size="xs" @class="indeterminate-icon" />
			{{/if}}
		</li>
	</template>
}
